<template>
    <div class="caBox" style="width: 100%">
        <!-- 月视图-->
        <template v-if="whichType === '2' && listDetail.length > 0 && listDetail.length <= 3">
            <el-popover v-for="(item, index) in listDetail" :key="index" placement="right" width="218" trigger="hover" popper-class="proMonth-detail-pop">
                <div class="proTime">
                    <div class="pro-title">
                        <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                            <span style="font-size: 18px; font-weight: bold">{{ item.title }}</span>
                        </el-tooltip>
                    </div>
                    <div class="pro-title">
                        <span>{{ item.startDate }}</span>
                        <span style="margin-left: 5px">{{ forMat(item.startDate).weekDate }}</span>
                        <i style="margin-left: 18px" class="el-icon-date" />
                    </div>
                    <div class="pro-title">
                        <span style="margin-right: 20px">{{ item.startTime }}</span>
                        <span v-text-lbl="'common.to'">至</span>
                        <span style="margin-left: 20px">{{ item.endTime }}</span>
                    </div>
                    <div v-if="item.address" class="pro-title">
                        <el-tooltip class="item" effect="dark" :content="item.address" placement="top-start">
                            <span>{{ item.address }}</span>
                        </el-tooltip>
                    </div>
                    <div class="pro-title">
                        <span v-fields-lbl="'promoter'">发起人：</span>
                        <span>{{ item.creator }}</span>
                    </div>
                    <div v-if="item.userName" style="position: relative; font-size: 12px">
                        <div style="margin: 10px 0; font-weight: 600" v-fields-lbl="'participants'">参与人：</div>
                        <div style="margin: 1px 0">{{ item.userName }}</div>
                    </div>
                </div>
                <div slot="reference" class="four-item" :style="{ height: bigScreen ? '28px' : '18px', width: '100%' }" @click.stop="getMonthDetail(item)">
                    <span class="four-spanC" :style="{ width: spanHeight }">{{ forMarTime(item.startTime) }} {{ item.title }}</span>
                </div>
            </el-popover>
        </template>
        <template v-if="whichType === '2' && listDetail.length > 3">
            <el-popover placement="right" width="218" trigger="hover" popper-class="pro-detail">
                <div class="four-pro">
                    <div class="pro-title">
                        <span>{{ forMat(listDetail[0].startDate).weekDate }} &nbsp;&nbsp;&nbsp;{{ forMat(listDetail[0].startDate).dateTime }}</span>
                    </div>
                    <div class="info-sco">
                        <div v-for="(iteme, index) in listDetail" :key="index" style="cursor: pointer" class="info-title" @click.stop="getMonthDetail(iteme)">
                            <span class="span-color" />
                            <span class="span-time">{{ forMarTime(iteme.startTime) }}~{{ forMarTime(iteme.endTime) }}</span>
                            <el-tooltip class="item" effect="dark" :content="iteme.title" placement="top-start">
                                <span class="span-title">{{ iteme.title }}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div slot="reference" class="four-itemA">
                    <el-tooltip class="item" effect="dark" :content="$tx('ecoa.calendar.share', { num: listDetail.length }, '共有{num}个会议')" placement="top">
                        <span class="four-spanC">{{ listDetail.length }}</span>
                    </el-tooltip>
                </div>
            </el-popover>
        </template>
        <!-- 日视图 -->
        <template v-if="whichType === '3' && listDetail.length > 0">
            <div class="box-time">
                <div class="content-time"></div>
                <div class="content-info">
                    <el-tooltip class="item" effect="dark" :content="shouOrOPen ? $tx('ecoa.calendar.open', '展开') : $tx('ecoa.calendar.swiup', '收起')" placement="top">
                        <svg-icon v-if="!shouOrOPen" icon-class="shouqi" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click="changType(1)" />
                        <svg-icon v-if="shouOrOPen" icon-class="zhankai" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click="changType(2)" />
                    </el-tooltip>
                </div>
            </div>
            <div v-for="(item, index) in listDetail" :key="index">
                <div class="box-time" :class="[{ canOPen: index < 7 }, { canOPenA: index > 17 && index <= 23 }]">
                    <div class="content-time">
                        <span v-if="item.valData.length > 0" class="content-title active">{{ item.title }}</span>
                        <span v-else class="content-title">{{ item.title }}</span>
                    </div>
                    <div class="content-info" @click="addData(item)">
                        <el-tooltip class="item" effect="dark" :content="shouOrOPenA ? $tx('ecoa.calendar.open', '展开') : $tx('ecoa.calendar.swiup', '收起')" placement="top">
                            <svg-icon v-if="!shouOrOPenA && index == 17" icon-class="shouqi" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click.stop="changTypeA(1)" />
                            <svg-icon v-if="shouOrOPenA && index == 17" icon-class="zhankai" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click.stop="changTypeA(2)" />
                        </el-tooltip>
                        <template v-if="item.valData.length > 0">
                            <el-popover v-for="(val, indexB) in item.valData" :key="indexB" placement="top" width="218" trigger="hover" popper-class="proTime-detail">
                                <div class="proTime">
                                    <div class="pro-title">
                                        <el-tooltip class="item" effect="dark" :content="val.listDetail.title" placement="top-start">
                                            <span>{{ val.listDetail.title }}</span>
                                        </el-tooltip>
                                    </div>
                                    <div class="pro-title">
                                        <span>{{ val.listDetail.startDate }}</span>
                                        <span style="margin-left: 5px">{{ forMat(val.listDetail.startDate).weekDate }}</span>
                                        <i style="margin-left: 18px" class="el-icon-date" />
                                    </div>
                                    <div class="pro-title">
                                        <span style="margin-right: 20px">{{ val.listDetail.startTime }}</span>
                                        至
                                        <span style="margin-left: 20px">{{ val.listDetail.endTime }}</span>
                                    </div>
                                    <div v-if="val.listDetail.address" class="pro-title">
                                        <el-tooltip class="item" effect="dark" :content="val.listDetail.address" placement="top-start">
                                            <span>{{ val.listDetail.address }}</span>
                                        </el-tooltip>
                                    </div>
                                    <div class="pro-title">
                                        <span v-fields-lbl="'promoter'">发起人：</span>

                                        <span>{{ val.listDetail.creator }}</span>
                                    </div>
                                    <div v-if="val.listDetail.userName" style="position: relative; font-size: 12px">
                                        <div style="margin: 10px 0; font-weight: 600" v-fields-lbl="'participants'">参与人：</div>
                                        <div style="margin: 1px 0">{{ val.listDetail.userName }}</div>
                                    </div>
                                </div>
                                <div v-if="!val.isEnd" slot="reference" class="info-box" :style="{ width: hasWitch(item.valData), height: val.timeHeight - 1 + 'px', top: val.startHeight + 'px', left: leftIndex(item.valData, indexB) }" @click.stop="getDetail(val.listDetail, false)">
                                    <span class="info-title">{{ val.listDetail.title }}</span>
                                    <span style="font-size: 14px">{{ forMarTime(val.listDetail.startTime) }}-{{ forMarTime(val.listDetail.endTime) }}</span>
                                </div>
                                <div v-if="val.isEnd" slot="reference" class="info-box-end" :style="{ width: hasWitch(item.valData), height: val.timeHeight - 1 + 'px', top: val.startHeight + 'px', left: leftIndex(item.valData, indexB) }" @click.stop="getDetail(val.listDetail, false)">
                                    <span class="info-title">{{ val.listDetail.title }}</span>
                                    <span style="font-size: 14px">{{ forMarTime(val.listDetail.startTime) }}-{{ forMarTime(val.listDetail.endTime) }}</span>
                                </div>
                            </el-popover>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- 周视图 -->
        <template v-if="whichType === '4' && listDetail.length > 0">
            <div class="week-time">
                <div class="week-content"></div>
                <div class="content-info">
                    <el-tooltip class="item" effect="dark" :content="shouOrOPen ? $tx('ecoa.calendar.open', '展开') : $tx('ecoa.calendar.swiup', '收起')" placement="top">
                        <svg-icon v-if="!shouOrOPen" icon-class="shouqi" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click="changType(1)" />
                        <svg-icon v-if="shouOrOPen" icon-class="zhankai" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click="changType(2)" />
                    </el-tooltip>
                    <div v-for="(itemA, indexC) in 7" :key="indexC" class="info-item" />
                </div>
            </div>
            <div v-for="(item, index) in listDetail" :key="index">
                <div class="week-time" :class="[{ canOPen: index < 7 }, { canOPenA: index > 17 && index <= 23 }]">
                    <div class="week-content">
                        <span class="content-title">{{ item.title }}</span>
                    </div>
                    <div class="content-info">
                        <el-tooltip class="item" effect="dark" :content="shouOrOPenA ? $tx('ecoa.calendar.open', '展开') : $tx('ecoa.calendar.swiup', '收起')" placement="top">
                            <svg-icon v-if="!shouOrOPenA && index == 17" icon-class="shouqi" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click.stop="changTypeA(1)" />
                            <svg-icon v-if="shouOrOPenA && index == 17" icon-class="zhankai" style="font-size: 14px; cursor: pointer; position: absolute; bottom: 5px; right: 0px; z-index: 333" @click.stop="changTypeA(2)" />
                        </el-tooltip>
                        <div v-for="(itemA, indexB) in item.valData" :key="indexB" class="info-item" @click="addData(item, indexB, 'week')">
                            <template v-if="itemA.listdata.length > 0">
                                <div v-for="(val, indexC) in itemA.listdata" :key="indexC" :style="{ width: weekWidth(itemA.listdata) }">
                                    <el-tooltip class="item" effect="dark" :content="val.listDetail.title" placement="top">
                                        <div v-if="!val.isEnd" class="info-box" :style="{ position: 'relative', width: '100%', height: val.timeHeight - 2 + 'px', 'margin-top': val.startHeight + 'px' }" @click.stop="getDetail(val.listDetail, false)">
                                            <span class="info-title">{{ val.listDetail.title }}</span>
                                        </div>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" :content="val.listDetail.title" placement="top">
                                        <div v-if="val.isEnd" class="info-box-end" :style="{ position: 'relative', width: '100%', height: val.timeHeight - 2 + 'px', 'margin-top': val.startHeight + 'px' }" @click.stop="getDetail(val.listDetail, false)">
                                            <span class="info-title">{{ val.listDetail.title }}</span>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        whichType: {
            type: String,
            default: '1'
        },
        listDetail: {
            type: Array,
            default: function () {
                return []
            }
        },
        weekArray: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            i18npkg: 'ecoa',
            moduleCode: 'calendar',
            monthClick: false,
            bigScreen: false,
            shouOrOPen: false,
            shouOrOPenA: false,
            liHeight: 0,
            spanHeight: '',
            calendarTime: ''
        }
    },
    watch: {},
    created() {},
    mounted() {
        const _this = this
        this.getWindowInfo()
        window.addEventListener('resize', this.getWindowInfo)
        this.initLine()
        if (this.whichType === '4') {
            setTimeout(() => {
                this.initLine()
            }, 100)
        }
        // 目标元素
        const targetElement = document.querySelector('.month-box')
        if (targetElement) {
            // 创建MutationObserver实例，传入回调函数
            const observer = new ResizeObserver((mutationsList, observer) => {
                // 处理DOM变化的逻辑
                _this.getWindowInfoA()
            })
            // 开始观察目标元素
            observer.observe(targetElement)
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowInfo)
    },
    methods: {
        initLine() {
            this.$nextTick(() => {
                if (document.querySelectorAll('.canOPen') && document.querySelectorAll('.canOPenA')) {
                    document.querySelectorAll('.canOPen').forEach((item) => {
                        item.style = 'display:none;'
                        this.shouOrOPen = true
                    })
                    document.querySelectorAll('.canOPenA').forEach((item) => {
                        item.style = 'display:none;'
                        this.shouOrOPenA = true
                    })
                }
                if (document.querySelectorAll('.el-scrollbar__view').length === 3) {
                    this.liHeight = document.querySelectorAll('.el-scrollbar__view')[2].clientHeight
                    this.$bus.emit('liH', this.liHeight)
                }
            })
        },
        changType(type) {
            if (type === 1) {
                if (!this.shouOrOPen) {
                    document.querySelectorAll('.canOPen').forEach((item) => {
                        item.style = 'display:none;'
                    })
                    this.shouOrOPen = true
                }
            } else {
                if (this.shouOrOPen) {
                    document.querySelectorAll('.canOPen').forEach((item) => {
                        item.style = 'display:flex;'
                    })
                    this.shouOrOPen = false
                }
            }
            if (document.querySelectorAll('.el-scrollbar__view').length === 3) {
                this.liHeight = document.querySelectorAll('.el-scrollbar__view')[2].clientHeight
                this.$bus.emit('liH', this.liHeight)
            }
        },
        changTypeA(type) {
            if (type === 1) {
                if (!this.shouOrOPenA) {
                    document.querySelectorAll('.canOPenA').forEach((item) => {
                        item.style = 'display:none;'
                    })
                    this.shouOrOPenA = true
                }
            } else {
                if (this.shouOrOPenA) {
                    document.querySelectorAll('.canOPenA').forEach((item) => {
                        item.style = 'display:flex;'
                    })
                    this.shouOrOPenA = false
                }
            }
            if (document.querySelectorAll('.el-scrollbar__view').length === 3) {
                this.liHeight = document.querySelectorAll('.el-scrollbar__view')[2].clientHeight
                this.$bus.emit('liH', this.liHeight)
            }
        },
        hasWitch(item) {
            if (item.length === 1) {
                return '98%'
            } else if (item.length > 1) {
                return Math.floor(98 / item.length) + '%'
            }
        },
        leftIndex(item, index) {
            if (item.length === 1) {
                return '1%'
            } else if (item.length > 1) {
                return (100 / item.length) * index + 0.5 + '%'
            }
        },
        weekWidth(item) {
            if (item.length === 1) {
                return '98%'
            } else if (item.length > 1) {
                return 98 / item.length + '%'
            }
        },
        forMarTime(val) {
            const value = val.split(':')
            return value[0] + ':' + value[1]
        },
        addData(item, index, type) {
            if (type === 'week') {
                const currentStart = this.weekArray[index].dataValue + ' ' + item.title
                const currentEnd = this.weekArray[index].dataValue + ' ' + (Number(item.timeDate) < 9 ? '0' + (item.title.split(':')[0] - 0 + 1) + ':00' : item.title.split(':')[0] - 0 + 1 + ':00')
                item.currentStart = currentStart
                item.currentEnd = currentEnd
            }
            this.$bus.emit('editForm', item, 'add', false)
        },
        getMonthDetail(vo) {
            const isEnd = false
            this.$bus.emit('editForm', vo, 'edit', isEnd)
        },
        getDetail(vo, isEnd) {
            this.$bus.emit('editForm', vo, 'edit', isEnd)
        },
        getWindowInfo() {
            clearTimeout(this.calendarTime)
            this.calendarTime = setTimeout(() => {
                if (document.querySelector('.month-box')) {
                    this.spanHeight = Math.floor((document.querySelector('.month-box').clientWidth - 56) / 7) + 'px'
                }
                if (document.body.clientWidth > 1600) {
                    this.bigScreen = true
                } else {
                    this.bigScreen = false
                }
            }, 500)
        },
        getWindowInfoA() {
            if (document.querySelector('.month-box')) {
                this.spanHeight = Math.floor((document.querySelector('.month-box').clientWidth - 56) / 7) + 'px'
            }
            if (document.body.clientWidth > 1600) {
                this.bigScreen = true
            } else {
                this.bigScreen = false
            }
        },
        forMat(time) {
            const week = ['日', '一', '二', '三', '四', '五', '六']
            const date = new Date(time)
            // const weekDate = '周' + week[date.getDay()]
            const weekDate = this.$tx('ecoa.calendar.weekDate', { day: week[date.getDay()] }, "'周' + week[date.getDay()]")
            // const dateTime = date.getMonth() + 1 + '月' + date.getDate() + '号'
            const dateTime = this.$tx('ecoa.calendar.dateTime', { month: date.getMonth() + 1, day: date.getDate() }, "date.getMonth() + 1 + '月' + date.getDate() + '号'")
            return {
                weekDate,
                dateTime
            }
        },
        // 获取当前时间结构
        nowLine() {
            var d = new Date()
            var hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
            var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
            var startHeight = minutes - 0 + (30 - 0)
            var time = hours + ':' + minutes
            return {
                hours,
                minutes,
                time,
                startHeight
            }
        }
    }
}
</script>
<style lang="scss">
.pro-detail {
    border-radius: 8px !important;
    .proTime {
        .pro-title {
            height: 40px;
            overflow: hidden;
            font-size: 12px;
            line-height: 40px;
            position: relative;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ebebeb;
        }
    }
}
.proWeek-detail {
    border-radius: 8px !important;
    .proTime {
        .pro-title {
            height: 40px;
            overflow: hidden;
            font-size: 12px;
            line-height: 40px;
            position: relative;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ebebeb;
        }
    }
}
.proTime-detail {
    border-radius: 8px !important;
    .proTime {
        .pro-title {
            height: 40px;
            overflow: hidden;
            font-size: 12px;
            line-height: 40px;
            position: relative;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ebebeb;
        }
    }
}
.proMonth-detail-pop {
    border-radius: 8px !important;
    height: unset !important;
    .proTime {
        .pro-title {
            height: 40px;
            overflow: hidden;
            font-size: 12px;
            line-height: 40px;
            position: relative;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ebebeb;
        }
    }
}
</style>
<style scope lang="scss">
.box-time {
    height: 60px;
    display: flex;
    .content-time {
        height: 100%;
        width: 60px;
        font-size: 14px;
        color: #929292;
        position: relative;
        .content-title {
            position: absolute;
            top: -8px;
            right: 10px;
        }
        .active {
            color: red;
            position: absolute;
            &::after {
                content: '';
                width: 5px;
                height: 5px;
                position: absolute;
                background: red;
                border-radius: 50%;
                left: 50%;
                bottom: -8px;
                transform: translateX(-50%);
            }
        }
    }
    .now-time {
        position: absolute;
        z-index: 66;
        width: 44px;
        height: 20px;
        font-size: 12px;
        text-align: center;
        color: white;
        line-height: 20px;
        background: var(--bgColor);
        border-radius: 4px;
        left: 3px;
    }
    .content-info {
        height: 100%;
        width: calc(100% - 60px);
        cursor: pointer;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        border-left: 1px solid #ebebeb;
        .info-box {
            color: var(--bgColor);
            font-size: 12px;
            border-radius: 4px;
            background: #eff2f6;
            position: absolute;
            border-left: 3px solid var(--bgColor);
            cursor: pointer;
            z-index: 10;
            display: flex;
            overflow: hidden;
            justify-content: space-between;
            align-items: center;
            padding: 0 7px;
            .info-title {
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                white-space: nowrap;
                display: inline-block;
                font-size: 14px;
            }
        }
        .info-box-end {
            color: #bbbdc2;
            font-size: 12px;
            border-radius: 5px;
            position: absolute;
            background: #f6f6f5;
            text-decoration: line-through;
            border: 0.5px solid rgba(228, 230, 236, 0.8);
            cursor: pointer;
            z-index: 10;
            display: flex;
            overflow: hidden;
            justify-content: space-between;
            align-items: center;
            padding: 0 7px;
            .info-title {
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                white-space: nowrap;
                display: inline-block;
                font-size: 14px;
            }
            .info-end {
                position: absolute;
                width: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 14px;
                background: #f9f9f9;
                right: 0px;
                top: 0px;
                border-bottom: 0.5px solid rgba(228, 230, 236, 0.8);
                border-left: 0.5px solid rgba(228, 230, 236, 0.8);
                border-radius: 0 0 0 5px;
            }
        }
    }
    .content-info:hover {
        background: rgba(47, 71, 126, 0.06);
    }
}
.week-time {
    height: 60px;
    display: flex;
    .week-content {
        height: 100%;
        width: 60px;
        font-size: 14px;
        color: #929292;
        position: relative;
        .content-title {
            position: absolute;
            top: -8px;
            right: 10px;
        }
        .active {
            color: red;
            position: absolute;
            &::after {
                content: '';
                width: 5px;
                height: 5px;
                position: absolute;
                background: red;
                border-radius: 50%;
                left: 50%;
                bottom: -8px;
                transform: translateX(-50%);
            }
        }
    }
    .now-time {
        position: absolute;
        z-index: 66;
        width: 44px;
        height: 20px;
        font-size: 12px;
        text-align: center;
        color: white;
        line-height: 20px;
        background: var(--bgColor);
        border-radius: 4px;
        left: 3px;
    }
    .content-info {
        height: 100%;
        width: calc(100% - 60px);
        cursor: pointer;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        border-left: 1px solid #ebebeb;
        display: flex;
        .info-item {
            width: 14.28%;
            border-right: 1px solid #ebebeb;
            height: 100%;
            justify-content: space-around;
            display: flex;
        }
        .info-item:hover {
            background: rgba(47, 71, 126, 0.06);
        }
        .info-item > span {
            width: 100%;
        }
        .info-box {
            color: var(--bgColor);
            font-size: 12px;
            border-radius: 4px;
            background: #eff2f6;
            border-left: 3px solid var(--bgColor);
            cursor: pointer;
            z-index: 10;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            justify-content: center;
            padding: 0 7px;
            .info-title {
                font-weight: bold;
                margin-top: 5px;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
                font-size: 14px;
            }
        }
        .info-box-end {
            color: #bbbdc2;
            font-size: 12px;
            border-radius: 5px;
            background: #f6f6f5;
            text-decoration: line-through;
            border: 0.5px solid rgba(228, 230, 236, 0.8);
            cursor: pointer;
            z-index: 10;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            justify-content: center;
            padding: 0 7px;
            .info-title {
                font-weight: bold;
                margin-top: 5px;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
                font-size: 14px;
            }
            .info-end {
                position: absolute;
                width: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 14px;
                background: #f9f9f9;
                right: 0px;
                top: 0px;
                border-bottom: 0.5px solid rgba(228, 230, 236, 0.8);
                border-left: 0.5px solid rgba(228, 230, 236, 0.8);
                border-radius: 0 0 0 5px;
            }
        }
    }
}
.item-third {
    width: 98px;
    display: flex;
    font-size: 12px;
    text-align: center;
    position: relative;
    height: 29px;
    line-height: 30px;
    color: #f76400;
    background: rgba(255, 191, 146, 0.22);
    border-radius: 2px;
    margin: 0 auto;
    margin-top: 5px;
    &:last-child {
        margin-top: 6px;
    }
    &::before {
        display: block;
        content: '';
        position: absolute;
        top: -1px;
        height: 1px;
        width: 99px;
        background: rgba(247, 100, 0, 0.6);
    }
}
.four-pro {
    .pro-title {
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
    }
    .info-title {
        height: 25px;
        font-size: 14px;
        display: flex;
        align-items: center;
        .span-title {
            margin-left: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 80px;
        }
        .span-time {
            margin-left: 10px;
        }
        .span-color {
            width: 6px;
            height: 6px;
            display: inline-block;
            background: var(--bgColor);
            transform: rotate(45deg);
        }
    }
}
.four-item {
    width: 100%;
    background: var(--bgColor) !important;
    display: flex;
    align-items: center;
    border-bottom: 1px solid white;
    //margin-top: 1px;
    .four-spanC {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        font-size: 14px;
        color: white !important;
        padding-left: 8px;
    }
}
.four-itemA {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--bgColor);
    display: flex;
    align-items: center;
    margin-top: 1px;
    .four-spanC {
        font-size: 14px;
        color: white !important;
        margin-left: 10px;
    }
}
</style>
